import {IAnnouncement} from "@torim-app/types";
import {adminUrlBuilder} from "@app/api/utils";

export class AnnouncementService {
  static readonly path = 'announcements';

  // Unseen "what's new" updates for this business — empty unless the user is its main user
  static async getActiveAnnouncements(): Promise<IAnnouncement[]> {
    const url = adminUrlBuilder({}, AnnouncementService.path);
    const response = await fetch(url, {
      method: 'get',
      headers: {'content-type': 'application/json'},
    });
    if (!response.ok) return [];
    return response.json();
  }

  static async markSeen(ids: string[]): Promise<void> {
    const url = adminUrlBuilder({}, `${AnnouncementService.path}/seen`);
    await fetch(url, {
      method: 'put',
      headers: {'content-type': 'application/json'},
      body: JSON.stringify({ids}),
    });
  }
}
